export default "/images/check.svg?cd8e43e48db62a7fa3c7e66d11c83e80";